var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{},[_c('b-row',_vm._l((_vm.portfolio),function(nft){return _c('b-col',{key:nft.id,attrs:{"sm":"6","lg":"4"}},[_c('card-nft-summary',{attrs:{"lease":_vm.getLeaseObj(nft.leases[0]),"nft":nft}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }